module['exports'] = [
  'شمال',
  'مشرق',
  'جنوب',
  'مغرب',
  'شمال مشرق',
  'سمال مغرب',
  'جنوب مشرق',
  'جنوب مغرب',
];
